//
//  SDKBlurToken.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { SupernovaError } from "../../core/errors/SDKSupernovaError";
import { TokenType } from "../enums/SDKTokenType";
import { DimensionToken } from "./SDKDimensionToken";
import { Token } from "./SDKToken";
import { v4 as uuidv4 } from "uuid";
export class BlurToken extends Token {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(versionId, baseToken, value, alias, properties, propertyValues) {
        super(baseToken, versionId, properties, propertyValues);
        this.tokenType = TokenType.blur;
        this.value = value;
        this.blurLayers = new Array();
        this.isVirtual = false;
        if (alias) {
            this.value.referencedTokenId = alias.id;
        }
    }
    static create(versionId, brandId, name, description, value, alias, referenceResolver, properties, propertyValues) {
        const baseToken = {
            // @ts-expect-error TS(2322): Type 'undefined' is not assignable to type 'string... Remove this comment to see the full error message
            id: undefined, // Ommited id will create new token
            persistentId: uuidv4(),
            brandId,
            designSystemVersionId: versionId,
            type: TokenType.blur,
            meta: {
                name,
                description,
            },
            data: {},
            customPropertyOverrides: [],
        };
        if (value !== null && value !== undefined) {
            // Raw value
            const tokenValue = this.blurValueFromDefinition(value, referenceResolver);
            return new BlurToken(versionId, baseToken, tokenValue, null, properties, propertyValues);
        }
        if (alias) {
            // Aliased value - copy and create raw from reference
            const tokenValue = {
                type: alias.value.type,
                radius: alias.value.radius,
                referencedTokenId: alias.id,
            };
            return new BlurToken(versionId, baseToken, tokenValue, null, properties, propertyValues);
        }
        throw SupernovaError.fromMessage("Border Token must be created using value or alias, but none was provided");
    }
    static blurValueFromDefinition(definition, referenceResolver) {
        if (!Object.hasOwn(definition, "radius") || !Object.hasOwn(definition, "type")) {
            throw SupernovaError.fromMessage(`Border definition is missing one of required properties (color, width), was ${JSON.stringify(definition)}`);
        }
        const value = {}; // Empty container
        const blurDefinition = definition;
        const radius = DimensionToken.dimensionValueFromDefinitionOrReference(blurDefinition.width, referenceResolver, TokenType.borderWidth);
        if (radius === undefined) {
            throw new Error(`Unable to resolve value 'radius' for blur token definition \n${JSON.stringify(definition, null, 2)}\n Did you possibly use incorrect reference?`);
        }
        value.radius = radius;
        value.type = blurDefinition.type;
        return value;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Writing
    toWriteObject() {
        const baseData = this.toBaseWriteObject();
        const specificData = baseData;
        specificData.data = BlurToken.valueToWriteObject(this.value);
        return specificData;
    }
    static valueToWriteObject(value) {
        var _a;
        const valueObject = !value.referencedTokenId
            ? {
                radius: {
                    aliasTo: undefined,
                    value: {
                        measure: value.radius.measure,
                        unit: value.radius.unit,
                    },
                },
                type: value.type,
            }
            : undefined;
        return {
            aliasTo: (_a = value.referencedTokenId) !== null && _a !== void 0 ? _a : undefined,
            // @ts-expect-error TS(2322): Type '{ radius: { aliasTo: undefined; value: { mea... Remove this comment to see the full error message
            value: valueObject,
        };
    }
}
